import { QuotationItem } from '@/core/domain/stock/Quotations/Quotations.types';
import { StockItem } from '@/core/domain/stock/StockItems/StockItems.types';
import { getRowKey } from '@/core/domain/stock/StockItems/StockItems.utils';
import { RequestPurchases } from '@/core/domain/workorder/RequestPurchase/RequestPurchase.types';
import { PageResult } from '@/core/request/PageResult';
import React, { ReactElement, ReactNode } from 'react';
import { RadioSelect } from '../CreateQuotationItemModal';
import PartsList from './PartsOrConsumablesList';
import RequestPurchasesList from './RequestPurchasesList';

interface Props {
  enabled: boolean;
  type: RadioSelect;
  companiesIds: number[];
  quotationItems?: PageResult<QuotationItem> | undefined;
  setSelectedStockItems: React.Dispatch<React.SetStateAction<StockItem[]>>;
  selectedStockItems: StockItem[];
  setSelectedRequestPurchases: React.Dispatch<
    React.SetStateAction<RequestPurchases[]>
  >;
  selectedRequestPurchases: RequestPurchases[];
}
const ItemsListByRadioSelected: React.FC<Props> = ({
  enabled,
  type,
  companiesIds,
  quotationItems,
  selectedStockItems,
  setSelectedStockItems,
  selectedRequestPurchases,
  setSelectedRequestPurchases,
}) => {
  const renderSelectionPartsOrConsumables = (
    _: boolean,
    record: StockItem,
    __: number,
    originNode: ReactNode,
  ) => {
    const disabled = quotationItems?.data.some((qi) => {
      if (record.partId) {
        return qi.partId === record.partId;
      }
      return qi.consumableId === record.consumableId;
    });

    const cloned = React.cloneElement(originNode as ReactElement, {
      disabled,
    });

    return cloned;
  };

  const renderSelectionRequestPurchases = (
    _: boolean,
    record: RequestPurchases,
    __: number,
    originNode: ReactNode,
  ) => {
    const disabled = quotationItems?.data.some((qi) => {
      if (record.id) {
        return qi.workItemId === record.workItemId;
      }
    });

    const cloned = React.cloneElement(originNode as ReactElement, {
      disabled,
    });

    return cloned;
  };

  return (
    <>
      {type === RadioSelect.OS ? (
        <RequestPurchasesList
          enabled={enabled}
          rowSelection={{
            preserveSelectedRowKeys: true,
            selectedRowKeys: selectedRequestPurchases.map((item) => item.id),
            onChange: (_, rows) => {
              setSelectedRequestPurchases(rows);
            },
            renderCell: renderSelectionRequestPurchases,
          }}
          companyId={companiesIds[0]}
        />
      ) : (
        <PartsList
          type={type}
          enabled={enabled}
          companiesIds={companiesIds}
          rowSelection={{
            preserveSelectedRowKeys: true,
            selectedRowKeys: selectedStockItems.map((item) => getRowKey(item)),
            onChange: (_, rows) => {
              setSelectedStockItems(rows);
            },
            renderCell: renderSelectionPartsOrConsumables,
          }}
        />
      )}
    </>
  );
};

export default ItemsListByRadioSelected;
